module.exports = __webpack_public_path__ + "img/NL556.f9ca7da0.png";